module.exports = __webpack_public_path__ + "resources/img/img_watchall_dbms_02_m_en.c8f6702fd1af907aedf0ee4ee4934a1c.png";